import httpRequest from '@/utils/request.js'

/**
 * @GET
 * @param {*} params
 *
 */
// 邮件日志列表
export const emailnoticelog = (params = {}) => httpRequest.httpGet({
  url: '/service/emailnoticelog/lst', params: {
    // type: params.type,
    ...params
  }
})

// 短信
export const messaglog = (params = {}) => httpRequest.httpGet({
  url: '/service/messagenoticelog/lst', params: {
    // type: params.type,
    ...params
  }
})
// 短信
export const messageDetail = (id) => httpRequest.httpGet({
  url: '/service/messagenoticelog/' + id,
})

// 语音
export const voiceNoticeLog = (params = {}) => httpRequest.httpGet({
  url: '/service/voiceNoticeLog/lst', params: {
    // type: params.type,
    ...params
  }
})

//日志查询
export const operateLog = (params = {}) => httpRequest.httpGet({
  url: '/service/syslog/log/findOnePage', params: {
    // type: params.type,
    ...params
  }
})
//日志设置查询
export const findOnePageLogSet = (params = {}) => httpRequest.httpGet({
  url: '/service/syslog/set/findOnePageLogSet', params: {
    // type: params.type,
    ...params
  }
})
export const operateSet = (params = {}) => httpRequest.httpGet({
  url: '/service/operateSet/getAll', params: {
    // type: params.type,
    ...params
  }
})
export const logdetail = (params = {}) => httpRequest.httpGet({
  url: '/service/emailnoticelog/' + params, params: {
    // type: params.type,
    // ...params
  }
})
export const voiceDetailLog = (params = {}) => httpRequest.httpGet({
  url: '/service/voiceNoticeLog/detail?id=' + params, params: {
    // type: params.type,
    // ...params
  }
})

export const syslogModules = (params = {}) => httpRequest.httpGet({
  url: '/service/syslog/set/modules', params: {
    ...params
  }
})
export const syslogId = (params = {}) => httpRequest.httpGet({
  url: '/service/syslog/set/' + params.id
})
export const syslogLogId = (params = {}) => httpRequest.httpGet({
  url: '/service/syslog/log/' + params.id
})

/**
* @POST
* @param {*} params
*
*/

export const addOrUpt = (data, loadingOptions) => httpRequest.httpPost('/service/operateSet/addOrUpt', data, loadingOptions)
export const syslogAdd = (data, loadingOptions) => httpRequest.httpPost('/service/syslog/set/add', data, loadingOptions)
export const syslogAddModule = (data, loadingOptions) => httpRequest.httpPost('/service/syslog/set/addModule', data, loadingOptions)



/**
 * @delete  删除
 * @param {*} params
 */
export const deletemail = (data, loadingOptions) => httpRequest.httpdelete('/service/emailnoticelog/del', data, loadingOptions)
export const deletemessage = (data, loadingOptions) => httpRequest.httpdelete('/service/messagenoticelog/del', data, loadingOptions)
export const deletevoice = (data, loadingOptions) => httpRequest.httpdelete('/service/voiceNoticeLog/delAll', data, loadingOptions)
export const deletoperateLog = (data, loadingOptions) => httpRequest.httpdelete('/service/operateLog/del', data, loadingOptions)
export const delebatchLog = (data, loadingOptions) => httpRequest.httpdelete('/service/voiceNoticeLog/del', data, loadingOptions)
export const syslogDelete = (data, loadingOptions) => httpRequest.httpdelete('/service/syslog/delete', data, loadingOptions)
export const syslogSetDelete = (data, loadingOptions) => httpRequest.httpdelete('/service/syslog/set/delete', data, loadingOptions)
export const syslogDelModules = (data, loadingOptions) => httpRequest.httpdelete('/service/syslog/set/delModules', data, loadingOptions)

/**
 * @put请求
 * @param {*} data
 *
 */
// export const saupUser = (params = {}) => httpRequest.httpPut({ url: '/service/role/right', ...params })
export const allotUsers = (data, loadingOptions) => httpRequest.httpPut('/service/role/user/auth', data)
export const syslogUpdate = (data, loadingOptions) => httpRequest.httpPut(
  '/service/syslog/set/update', data
)
export const syslogUpdateModule = (data, loadingOptions) => httpRequest.httpPut(
  '/service/syslog/set/updateModule' + `?id=${data.id}&name=${data.name}`
)
export const syslogSetSwitch = (data, loadingOptions) => httpRequest.httpPut('/service/syslog/set/setSwitch' + `?id=${data.id}&switch=${data.switch}`)
